import type { RankingEvalTypeId } from './rankingEvaluationNav';

export interface EvaluatorTheme {
  id: RankingEvalTypeId;
  gradient: string;
  gradientInactive: string;
  accent: string;
  panelBg: string;
  panelBorder: string;
  textOnTab: string;
  textInactive: string;
  glossHighlight: string;
}

export const EVALUATOR_THEMES: Record<RankingEvalTypeId, EvaluatorTheme> = {
  'self-evaluation': {
    id: 'self-evaluation',
    gradient: 'linear-gradient(180deg, #22d3ee 0%, #0891b2 55%, #0e7490 100%)',
    gradientInactive: 'linear-gradient(180deg, #cffafe 0%, #67e8f9 55%, #22d3ee 100%)',
    accent: '#0891b2',
    panelBg: 'linear-gradient(180deg, #f0fdff 0%, #ffffff 28%)',
    panelBorder: '#0891b2',
    textOnTab: '#ffffff',
    textInactive: '#0e7490',
    glossHighlight: 'linear-gradient(180deg, rgba(255,255,255,0.45) 0%, rgba(255,255,255,0) 48%)',
  },
  'coach-academy': {
    id: 'coach-academy',
    gradient: 'linear-gradient(180deg, #60a5fa 0%, #2563eb 55%, #1d4ed8 100%)',
    gradientInactive: 'linear-gradient(180deg, #dbeafe 0%, #93c5fd 55%, #60a5fa 100%)',
    accent: '#2563eb',
    panelBg: 'linear-gradient(180deg, #eff6ff 0%, #ffffff 28%)',
    panelBorder: '#2563eb',
    textOnTab: '#ffffff',
    textInactive: '#1e40af',
    glossHighlight: 'linear-gradient(180deg, rgba(255,255,255,0.42) 0%, rgba(255,255,255,0) 48%)',
  },
  'practical-test': {
    id: 'practical-test',
    gradient: 'linear-gradient(180deg, #fb923c 0%, #9333ea 52%, #6b21a8 100%)',
    gradientInactive: 'linear-gradient(180deg, #fde68a 0%, #d8b4fe 52%, #a78bfa 100%)',
    accent: '#9333ea',
    panelBg: 'linear-gradient(180deg, #faf5ff 0%, #ffffff 28%)',
    panelBorder: '#9333ea',
    textOnTab: '#ffffff',
    textInactive: '#6b21a8',
    glossHighlight: 'linear-gradient(180deg, rgba(255,255,255,0.4) 0%, rgba(255,255,255,0) 48%)',
  },
};

export const getEvaluatorTheme = (evalId: RankingEvalTypeId) => EVALUATOR_THEMES[evalId];
